import { TrainType } from '@app/pcs/models/train-type';
import { cargoTrainComposition } from '@dossier/models/cargo-train-composition';
import { passengerTrainComposition } from '@dossier/models/passenger-train-composition';
import {gql} from 'apollo-angular';

export interface TrainComposition {
  id?: number;
  dossierId?: number;
  trainHeadNote1?: string;
  trainHeadNote2?: string;
  freeText?: string;
  trainType?: TrainType;
}

export enum TrainCompositionAclActionMap {
  EditTrainComposition = 'EditTrainComposition'
}

export const trainComposition = gql`
  fragment trainComposition on TrainComposition {
    id
    dossierId
    trainHeadNote1
    trainHeadNote2
    freeText
    trainType {
      id
      description
    }
    ... on CargoTrainComposition {
      ...cargoTrainComposition
    }
    ... on PassengerTrainComposition {
      ...passengerTrainComposition
    }
  }
  ${cargoTrainComposition}
  ${passengerTrainComposition}
`;
